import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 270px 1fr;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.85);
  overflow: auto;
`;

export const Gradient = styled.div`
  background: linear-gradient(5deg, #960014 5%, #595E69 1%, #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`
export const HeaderLogin = styled.div`
  display: grid;
  grid-template-rows: auto auto 18px;
  gap: 3px 0;
  font-weight: 500;
  font-size: 27px;
  color: #fff;
  @media (max-height: 568px) {
    padding-left: 90px;
    font-size: 18px;
    gap: 0;
  }
  @media (max-width: 321px) {
    padding-left: 90px;
    font-size: 18px;
    gap: 0;
  }
`

export const BodyLogin = styled.div`
  & form {
    display: grid;
    grid-template-rows: auto;
    gap: 17px 0;
  }
`;

export const FooterLogin = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  & span {
    padding-top: 16px;
    font-size: 13px;
    text-align: center;
  }
`;